import { CanDeactivateFn } from '@angular/router';
import { ComponentCanDeactivate } from './component.can.deactivate';

export const exitGuard: CanDeactivateFn<ComponentCanDeactivate> = (
	component: ComponentCanDeactivate,
	currentRoute,
	currentState,
	nextState,
) => {
	return component.canDeactivate ? component.canDeactivate() : true;
};
